import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { StoreProvider } from "./context/Store";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { CartSheet } from "./components/CartSheet";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductPage from "./pages/ProductPage";
import Login from "./pages/Login";
import Checkout from "./pages/Checkout";
import Orders from "./pages/Orders";
import PaymentResult from "./pages/PaymentResult";
import AuthCallback from "./pages/AuthCallback";
import Admin from "./pages/Admin";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/product/:id" element={<ProductPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/orders" element={<Orders />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/payment/success" element={<PaymentResult />} />
      <Route path="/payment/paypal" element={<PaymentResult />} />
      <Route path="/payment/cancel" element={<PaymentResult />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <StoreProvider>
        <div className="min-h-screen bg-[#FAF7F2] text-[#1A1714] font-body">
          <Header />
          <main><AppRouter /></main>
          <Footer />
          <CartSheet />
          <Toaster position="top-center" richColors />
        </div>
      </StoreProvider>
    </BrowserRouter>
  );
}
